module.exports = __webpack_public_path__ + "img/ainao.0c4bfd09.jpg";